export default (val: number | string) => {
  if (!isNaN(+val)) {
    return `${val}px`
  }

  return val
}
